module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "6ll1ji33",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
    token: process.env.GATSBY_SANITY_TOKEN
  }
};
